import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import shape1 from '../../images/background/pattern-24.png'
import classnames from 'classnames';
import { Link } from 'react-router-dom'
import Events from '../../api/Events';

const EventsSection3 = (props) => {

    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <section className="speakers-four" id='events'>
            <div className="speakers-four_pattern" style={{ backgroundImage: `url(${shape1})` }}></div>
            <div className="auto-container">
                <div className="sec-title">
                    <div className="sec-title_title">RETREAT AGENDA</div>
                    <h2 className="sec-title_heading">Join The World's Leading <br /> Companies at Technology <br /> Conference</h2>
                </div>
                <div className="inner-container">
                    <div className="speaker-info-tabs">
                        <div className="speaker-tabs_two tabs-box">
                            <ul>
                                <Nav tabs className="tab-btns tab-buttons clearfix">
                                    <NavItem className='tab-btn'>
                                        <NavLink
                                            className={classnames({ active: activeTab === "1" })}
                                            onClick={() => { toggle("1"); }}
                                        >
                                            <span>1st Day</span> oct <strong>05</strong><i>2023</i>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className='tab-btn'>
                                        <NavLink
                                            className={classnames({ active: activeTab === "2" })}
                                            onClick={() => { toggle("2"); }}
                                        >
                                            <span>2nd Day</span>Nov <strong>06</strong><i>2023</i>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className='tab-btn'>
                                        <NavLink
                                            className={classnames({ active: activeTab === "3" })}
                                            onClick={() => { toggle("3"); }}
                                        >
                                            <span>3rd Day</span>Dec <strong>07</strong><i>2023</i>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </ul>
                            <div className="tabs-content">
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId='1'>
                                        {Events.slice(0, 4).map((event, i) => (
                                            <div className="content" key={i}>
                                                <div className="leadership-three_block" >
                                                    <div className="leadership-three_block-inner">
                                                        <div className="leadership-three_block-content">
                                                            <div className="leadership-three_block-image">
                                                                <img src={event.eImg} alt="" />
                                                            </div>
                                                            <div className="leadership-three_block-name">{event.speaker} <span>Art Critic</span></div>
                                                            <h3 className="leadership-three_block-title"><Link onClick={ClickHandler} to={`/event-details/${event.slug}`}>{event.eTitle}</Link></h3>
                                                            <div className="leadership-three_block-location"><span>Location:</span> Hall 1, Building A , Golden Street , Southafrica</div>
                                                            <div className="leadership-three_block-timing">{event.time}</div>
                                                        </div>
                                                        <div className="leadership-three_block-icon fi flaticon-voice"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </TabPane>
                                    <TabPane tabId='2'>
                                        {Events.slice(2, 4).map((event, eb2) => (
                                            <div className="content" key={eb2}>
                                                <div className="leadership-three_block" >
                                                    <div className="leadership-three_block-inner">
                                                        <div className="leadership-three_block-content">
                                                            <div className="leadership-three_block-image">
                                                                <img src={event.eImg} alt="" />
                                                            </div>
                                                            <div className="leadership-three_block-name">{event.speaker} <span>Art Critic</span></div>
                                                            <h3 className="leadership-three_block-title"><Link onClick={ClickHandler} to={`/event-details/${event.slug}`}>{event.eTitle}</Link></h3>
                                                            <div className="leadership-three_block-location"><span>Location:</span> Hall 1, Building A , Golden Street , Southafrica</div>
                                                            <div className="leadership-three_block-timing">{event.time}</div>
                                                        </div>
                                                        <div className="leadership-three_block-icon fi flaticon-voice"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </TabPane>
                                    <TabPane tabId='3'>
                                        {Events.slice(1, 4).map((event, eb3) => (
                                            <div className="content" key={eb3}>
                                                <div className="leadership-three_block" >
                                                    <div className="leadership-three_block-inner">
                                                        <div className="leadership-three_block-content">
                                                            <div className="leadership-three_block-image">
                                                                <img src={event.eImg} alt="" />
                                                            </div>
                                                            <div className="leadership-three_block-name">{event.speaker} <span>Art Critic</span></div>
                                                            <h3 className="leadership-three_block-title"><Link onClick={ClickHandler} to={`/event-details/${event.slug}`}>{event.eTitle}</Link></h3>
                                                            <div className="leadership-three_block-location"><span>Location:</span> Hall 1, Building A , Golden Street , Southafrica</div>
                                                            <div className="leadership-three_block-timing">{event.time}</div>
                                                        </div>
                                                        <div className="leadership-three_block-icon fi flaticon-voice"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default EventsSection3;